let challengeObjectResponse = {
  U: {
    title: 'Transacción rechazada',
    body: 'No se ha podido realizar la petición por problemas técnicos',
  },
  N: {
    title: 'Transacción rechazada',
    body: 'La información de su cuenta no se ha podido verificar, inténtalo de nuevo más tarde o comunícate con tu banco',
  },
  R: {
    title: 'Transacción rechazada',
    body: 'No se ha podido comprobar la autenticidad de la cuenta, inténtalo de nuevo más tarde o comunícate con tu banco'
  },
  A: {
    title: 'Transacción rechazada',
    body: 'La petición ha sido rechazada, inténtalo de nuevo más tarde o comunícate con tu banco'
  }
};
export const CHALLENGE_OBJECT_RESPONSE = challengeObjectResponse;
